(function ($) {
  $(document).ready(function () {

	const variantInfo = document.getElementById('variant-data')
	const productInfo = document.getElementById('product-data')
	const variantRadios = document.querySelectorAll('variant-radios input[type="radio"]');
	const variantData = variantInfo ? JSON.parse(variantInfo.textContent) : false;
	const productData = productInfo ? JSON.parse(productInfo.textContent) : false;
    
    variantRadios.forEach(radio => {
      radio.addEventListener('change', function() {
       updateVariantImage()
      });
    });
    
    function updateVariantImage() {
		const selectedOptions = Array.from(document.querySelectorAll('variant-radios input[type="radio"]:checked'))
			.map(input => input.value);
		
		const variantsJson = document.querySelector('variant-radios script[type="application/json"]').textContent;
		const variants = JSON.parse(variantsJson);
		const test = 1;

		// Backfill with null for missing options
			while (selectedOptions.length < 3) {
				selectedOptions.push(null);
			}

		const currentVariant = variants.find(v => 
			v.option1 === selectedOptions[0] && 
			v.option2 === selectedOptions[1] && 
			v.option3 === selectedOptions[2]
		);
		
		if (currentVariant && currentVariant.featured_media) {
			// Use media ID to find the image
			const targetImage = document.querySelector(`.main-img .item-img[data-media-id="${currentVariant.featured_media.id}"]`);
			
			if (targetImage) {
			const slideIndex = parseInt(targetImage.getAttribute('data-slide'));
			goToSlide(slideIndex);
			}
		}

		if (currentVariant) {
			// Parse the variant specifications
		if (variantInfo) {
			updateAccordionContent(currentVariant.id)
		}
		}
	}

	function goToThumb(index) {
		// Slide thumbnails
  		var thumb = $('.item-list[data-slide=' + index + ']')
		thumb.addClass('active');

  		$('.img-thumbnail').animate({
  			left: 0 - thumb.position().left
  		}, 300);
	}

	function goToSlide(index) {
		$('.item-img').removeClass('active');
  		$('.item-list').removeClass('active');

		var mainImage = $('.item-img[data-slide=' + index + ']')
  		mainImage.addClass('active');

  		$('.main-img').animate({
  			left: 0 - mainImage.position().left
  		}, 500);

  		 goToThumb(index)
	}
 
  	$('.item-list').click(function () {
  		goToSlide($(this).index())
  	});

  	// Click next
  	$('.next').click(function () {
  		const nextImage = $('.item-img.active').next();
		var index = nextImage.index() 

  		$('.item-img').removeClass('active');
  		$('.item-list').removeClass('active');

  		

  		if (nextImage.length == 0) {
  			$('.main-img').animate({
  				left: 0 - $('.item-img:first-child').position().left
  			}, 500);

  			$('.item-img:first-child').addClass('active');
  			$('.item-list:first-child').addClass('active');
			index = 0
  		} else {
  			nextImage.addClass('active');
  			$('.main-img').animate({
  				left: 0 - nextImage.position().left
  			}, 500);
  		}

		goToThumb(index)
  	})

  	// Click prev
  	$('.prev').click(function () {
  		const prevImage = $('.active').prev();
		var index = prevImage.index() 

  		$('.item-img').removeClass('active');
  		$('.item-list').removeClass('active');

		  
  		if (prevImage.length == 0) {
			  $('.main-img').animate({
				  left: 0 - $('.item-img:last-child').position().left
				}, 500);
				
				$('.item-img:last-child').addClass('active');
				$('.item-list:last-child').addClass('active');
							index = $('.item-list:last-child').index() 

			} else {
			  prevImage.addClass('active');
			  $('.main-img').animate({
				  left: 0 - prevImage.position().left
			  }, 500);
		}

  			goToThumb(index)


  	})



    // Function to parse nested metafield JSON
    function parseMetafieldValue(value) {
        if (!value) return null;
        try {
            if (value.children && value.children[0] && 
                value.children[0].children && value.children[0].children[0]) {
                return value.children[0].children[0].value;
            }
        } catch (e) {
            console.error('Error parsing metafield:', e);
        }
        return null;
    }

    // Function to update accordion content - only needed if there are variants
    function updateAccordionContent(variantId) {
		
        const variant = variantData[variantId];
        
        // Update Description
        const descContainer = document.querySelector('.accordion-item:nth-child(1) .accordion-content');
        if (descContainer) {
            const text = parseMetafieldValue(variant?.description) || 
                        parseMetafieldValue(productData.description) || 
                        'No description available.';
            descContainer.innerHTML = `<p>${text.replace(/\n/g, '<br>')}</p>`;
        }

        // Update Features
        const featContainer = document.querySelector('.accordion-item:nth-child(2) .accordion-content');
        if (featContainer) {
            const text = parseMetafieldValue(variant?.features) || 
                        parseMetafieldValue(productData.features) || 
                        'No features available.';
            featContainer.innerHTML = `<p>${text.replace(/\n/g, '<br>')}</p>`;
        }

        // Update Specifications
        const specContainer = document.querySelector('.accordion-item:nth-child(3) .accordion-content');
        if (specContainer) {
            const text = parseMetafieldValue(variant?.specifications) || 
                        parseMetafieldValue(productData.specifications) || 
                        'No specifications available.';
            specContainer.innerHTML = `<p>${text.replace(/\n/g, '<br>')}</p>`;
        }

		// Update shipping timeline
		const timeContainer = document.querySelector('.product-shipping-timeline');
        if (timeContainer) {
            const text = (variant?.timeline) || 
                        (productData.timeline) || 
                        '- call for timeline';
            timeContainer.innerHTML = `${text}`;
        }
    }


  });
})(jQuery);
